import React, { useEffect, useState } from 'react';
import { getApi } from 'redux/apis';
import styles from './index.module.scss';
import { toastText } from 'utils/utils';
import { useSearchParams, useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';

const QuickbooksDisconnectCallback = () => {
	const [isLoading, setIsLoading] = useState(false);

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	useEffect(() => {
		const run = async () => {
			setIsLoading(true);

			try {
				// Extract current user's email from accessToken
				const currentAccessToken = localStorage.getItem('accessToken');
				if (!currentAccessToken) {
					toastText('Please login to continue', 'error');
					localStorage.clear();
					navigate('/login');
					return;
				}

				let userEmail: string | null = null;
				try {
					const decoded: any = jwtDecode(currentAccessToken);
					userEmail = decoded?.email;

					if (!userEmail) {
						toastText('Unable to identify user. Please login again.', 'error');
						localStorage.clear();
						navigate('/login');
						return;
					}
				} catch (err) {
					console.error('Error decoding token:', err);
					toastText('Invalid session. Please login again.', 'error');
					localStorage.clear();
					navigate('/login');
					return;
				}

				const realmId = searchParams.get('realmId') as string;
				if (!realmId) {
					toastText('Invalid disconnect request', 'error');
					navigate('/');
					return;
				}

				// Store email and realmId for later use
				localStorage.setItem('disconnect-userEmail', userEmail);
				localStorage.setItem('disconnect-companyId', realmId);
				localStorage.setItem('isLogin', 'true');

				const response = await getApi('/quickbooks/sso-authurl');
				window.open(response.data.data, '_self');
			} catch (err) {
				setIsLoading(false);
				toastText('Something went wrong in login', 'error');
			}
		};

		if (searchParams.get('realmId')) {
			run();
		} else {
			toastText('Invalid disconnect request', 'error');
			setIsLoading(false);
			navigate('/');
		}
	}, [searchParams, navigate]);

	return (
		<div className={styles['main-container']}>
			{isLoading && <img src="assets/gifs/loading-black.gif" />}
		</div>
	);
};

export default QuickbooksDisconnectCallback;
